import { Redirect, Route } from 'react-router';
import { ROUTE_PATH } from './route-paths';
import { Switch } from 'react-router-dom';
import PwaRedirectPage from '../containers/redirect-pages/pwa-redirect-page';

export const PeerRouter = () => {
  return (
    <Switch>
      <Route exact path={ROUTE_PATH.PWA_REDIRECT_PAGE} component={PwaRedirectPage} />
      <Route path="*" render={() => <Redirect to={ROUTE_PATH.PWA_REDIRECT_PAGE} />} />
    </Switch>
  );
};
